<template>
  <div class="wrapper">
    <div class="banner">
      <video class="video"
             type="video/mp4"
             autoplay
             loop
             src="http://media.jianzb.cn/sp/0813/qdhz0813.mp4">
      </video>
      <div class="banner-mask">
        <div class="mask-content">
          <div class="title">代理商火热招商中</div>
          <div class="apply">
            <a href="http://form.jianzb.cn/public/portal/article/index/id/38/v/2133128255.html
" target="_blank">申请入驻</a>
          </div>
        </div>
      </div>
    </div>
    <div class="icons-wrapper">
      <div class="icons">
        <div class="icon">
          <img src="../../assets/img/cooperation/icon1.png"/>
          <p class="category">高返点</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon2.png"/>
          <p class="category">系统培训</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon3.png"/>
          <p class="category">资源供给</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon4.png"/>
          <p class="category">营销支持</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon5.png"/>
          <p class="category">物料设计</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon6.png"/>
          <p class="category">技术支持</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon7.png"/>
          <p class="category">售后维保</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon8.png"/>
          <p class="category">区域保护</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon9.png"/>
          <p class="category">销售辅导</p>
        </div>
        <div class="icon">
          <img src="../../assets/img/cooperation/icon10.png"/>
          <p class="category">现场支持</p>
        </div>
      </div>
    </div>
    <div class="content-wrapper" id="standard">
      <div class="title">“鉴真宝”入驻标准</div>
      <div class="blocks">
      <div class="block block1">
        <div class="standard">
          <div class="title">1、诚信企业</div>
          <div class="explain">入驻"鉴真宝"的生产企业必须是诚信企业，无劳动纠纷，无任何法律污点，在社会上拥有良好的企业形象</div>
        </div>
      </div>
      <div class="block block2">
        <div class="standard">
          <div class="title">2、品牌企业</div>
          <div class="explain">"鉴真宝"要求只对品牌企业提供技术服务，入驻"鉴真宝"的品牌商品必须优质、安全、环保</div>
        </div>
      </div>
      <div class="block block3">
        <div class="standard">
          <div class="title">3、知名品牌</div>
          <div class="explain">"鉴真宝"要求入驻品牌为省市名牌和国际奢侈品品牌，能够提供完善的品牌服务。</div>
        </div>
      </div>
      <div class="block block4">
        <div class="standard">
          <div class="title">4、优秀法人</div>
          <div class="explain">"鉴真宝"不仅针对品牌企业、品牌商品，同业也要求入驻品牌的企业法人拥有创新意识、执行力、情怀和财富</div>
        </div>
      </div>
    </div>
    </div>
    <div class="content-wrapper" id="agent">
      <div class="title">“鉴真宝”代理机制</div>
      <div class="box">
        <div class="wrap">
          <div class="ptitle">1、哪些机构可以成为"鉴真宝"代理</div>
          <div class="table">
            <ul>
              <li class="head">行业组织</li>
              <li>服装产业协会</li>
              <li>物联网协会</li>
              <li>羽绒服协会</li>
              <li>皮革协会</li>
              <li>箱包协会</li>
              <li>鞋类协会</li>
              <li>其他协会</li>
            </ul>
            <ul>
              <li class="head">投资机构</li>
              <li>金融机构</li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
            <ul>
              <li class="head">品牌企业</li>
              <li>服装品牌</li>
              <li>箱包品牌</li>
              <li>烟酒品牌</li>
              <li>鞋类品牌</li>
              <li>珠宝品牌</li>
              <li>母婴品牌</li>
              <li>其他品牌</li>
            </ul>
            <ul>
              <li class="head">营销机构</li>
              <li>广告创意</li>
              <li>营销策划</li>
              <li>数字营销</li>
              <li>品牌代理</li>
              <li>搜索推广</li>
              <li>网红孵化</li>
              <li>影视制作</li>
            </ul>
            <ul>
              <li class="head">新锐团队</li>
              <li>创业团队</li>
              <li>设计团队</li>
              <li>电商团队</li>
              <li>产业联盟</li>
              <li>金融团队</li>
              <li>海归团队</li>
              <li>其他团队</li>
            </ul>
            <ul>
              <li class="head">地方媒体</li>
              <li>电视台</li>
              <li>自媒体机构</li>
              <li>杂志</li>
              <li>报业</li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box" style="background: #F8F8F8">
        <div class="wrap">
          <div class="ptitle">2、成为"鉴真宝"代理的条件</div>
          <div class="begin"></div>
          <div class="end"></div>
          <div class="condition-wrap">
            <div class="condition condition1">
              <div class="ctitle">企业非个人</div>
              <p class="need">代理必须提供企业营业证明、具有足够的资金、人员、资源条件作为代理基础</p>
            </div>
            <div class="condition condition2">
              <div class="ctitle">境外代理提供证明</div>
              <p class="need">如代理为境外企业，必须提供在中国的固定办公证明、相关运营团队证明及缴税证明等。</p>
            </div>
            <div class="condition condition3">
              <div class="ctitle">拥有丰富的行业资源</div>
              <p class="need">必须提供能够证明在某一行业或多个行业具有丰富资源的身份证明、材料证明等，如服装协会会长。</p>
            </div>
            <div class="condition condition4">
              <div class="ctitle">诚信组织</div>
              <p class="need">代理必须是诚信机构，在法律上没有任何纠纷和污点，在社会上拥有良好的业务信用。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <online-service>
    </online-service>
  </div>
</template>

<script>
  import OnlineService from '../common/OnlineService'
  import utils from '@/assets/js/utils'
  export default {
    name: 'cooperation-page',
    components: {
      OnlineService
    },
    data() {
      return {}
    },
    methods: {
      pageScroll(hash) {
        if (hash) {
          let el = document.getElementById(hash.replace('#', ''))
          utils.scroll2Pos(el, this)
        }
      }
    },
    mounted() {
      this.pageScroll(this.$route.hash)
    },
    watch: {
      '$route'(to, from) {
        this.pageScroll(to.hash)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .wrapper
    .banner
      position: relative
      min-width: 1200px
      height: 100vh
      .video
        width: 100%
        height: 100vh
        object-fit: cover
      .banner-mask
        position: absolute
        top: 0
        width: 100%
        height: 100vh
        color: #ffffff
        background-color: rgba(0, 0, 0, .4)
        text-align: center
        .mask-content
          position: absolute
          width: 1000px
          height: 200px
          top: 0
          left: 0
          right: 0
          bottom: 0
          margin: auto
          .title
            font-size: 100px
            letter-spacing: 2px
          .small-title
            margin-top: 44px
            font-size: 25px
          .apply
            margin: 60px auto
            width: 140px
            height: 50px
            line-height: 50px
            text-align: center
            border: 2px solid #ffffff
            border-radius: 4px
            cursor: pointer
            transition: all .2s
            &:hover
              background: #ffffff
              a
                color: #000000
            a
              font-size: 27px
              color: #ffffff
    .icons-wrapper
      width: 100%
      height: 70px
      background: #F7F8FA
      padding: 20px 0 10px
      .icons
        width: 1200px
        height: 70px
        margin: 0 auto
        display: flex
        .icon
          flex: 1
          text-align: center
          position: relative
          .category
            position: absolute
            width: 100%
            bottom: 0
            color: #595961
            font-size: 14px
    .content-wrapper
      .title
        padding-top: 82px
        text-align: center
        font-size: 35px
        color: #595959
        /*font-weight: bold*/
      .blocks
        display: flex
        min-width: 1200px
        margin: 80px auto 0
        flex-wrap: wrap
        .block
          width: 50%
          height: 224px
          background-repeat: no-repeat
          position: relative
          .standard
            position: absolute
            width: 460px
            text-align: left
            .title
              font-size: 24px
              color: #595959
              padding: 50px 0 30px
              text-align: left
              /*font-weight: bold*/
            .explain
              padding-left: 45px
              color: #777777
              line-height: 30px
          &.block1
            background-color: #F8F8F8
            background-image: url("../../assets/img/help/block1.png")
            background-size: 149px 149px
            background-position: 35% 75px
            .standard
              right: 56px
          &.block2
            background-color: #F2F2F2
            background-image: url("../../assets/img/help/block2.png")
            background-size: 194px 177px
            background-position: 65% 47px
            .standard
              left: 80px
          &.block3
            background-color: #F2F2F2
            background-image: url("../../assets/img/help/block3.png")
            background-size: 162px 152px
            background-position: 35% 72px
            .standard
              right: 56px
          &.block4
            background-color: #F8F8F8
            background-image: url("../../assets/img/help/block4.png")
            background-size: 168px 147px
            background-position: 65% 77px
            .standard
              left: 80px

      .box
        .wrap
          width: 960px
          margin: 0 auto
          padding-bottom: 100px
          position: relative
          .ptitle
            font-size: 25px
            color: #595959
            padding-top: 80px
          .table
            margin: 50px auto 0
            display: flex
            border-top: 1px solid #EFEFEF
            border-left: 1px solid #EFEFEF
            ul
              flex: 1
              li
                text-align: center
                font-size: 20px
                line-height: 50px
                height: 50px
                color: #888888
                border-bottom: 1px solid #EFEFEF
                border-right: 1px solid #EFEFEF
                &:nth-of-type(2n + 1)
                  background: #F5F5F5
                &.head
                  background: #0096FC
                  color: #ffffff
          .condition-wrap
            margin-top: 100px
            .condition
              width: 740px
              height: 120px
              background-color: #ffffff
              border-radius: 4px
              margin-bottom: 38px
              &.condition1
                margin-left: 65px
                background-image: url("../../assets/img/cooperation/cond1.png")
                background-size: 41px 78px
                background-repeat: no-repeat
                background-position: 20px 10px
              &.condition2
                margin-left: 166px
                background-image: url("../../assets/img/cooperation/cond2.png")
                background-size: 63px 76px
                background-repeat: no-repeat
                background-position: 20px 15px
              &.condition3
                margin-left: 65px
                background-image: url("../../assets/img/cooperation/cond3.png")
                background-size: 70px 83px
                background-repeat: no-repeat
                background-position: 10px 10px
              &.condition4
                margin-left: 166px
                background-image: url("../../assets/img/cooperation/cond4.png")
                background-size: 70px 79px
                background-repeat: no-repeat
                background-position: 10px 10px
              .ctitle
                font-size: 18px
                color: #595959
                padding: 30px 0 0 64px
                /*font-weight: bold*/
              .need
                font-size: 15px
                color: #888888
                margin: 22px 0 0 80px
          .begin
            position: absolute
            left: 0
            top: 162px
            width: 50px
            height: 45px
            background-image: url("../../assets/img/cooperation/begin.png")
            background-size: 50px 45px
            background-repeat: no-repeat
          .end
            position: absolute
            right: 0
            bottom: 80px
            width: 50px
            height: 44px
            background-image: url("../../assets/img/cooperation/end.png")
            background-size: 50px 44px
            background-repeat: no-repeat
</style>